function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.7439 1.73212C2.70463 10.1849 4.59264 18.8224 9.05574 26.08C13.4611 33.2336 20.3723 38.6494 28.3112 41.3688C32.8262 42.9162 37.526 43.609 42.2894 43.3781C43.2247 43.3319 44.0215 44.2037 44.0215 45.1102C44.0215 46.086 43.2247 46.7961 42.2894 46.8423C33.2535 47.2811 24.0617 44.5213 16.729 39.2383C9.23473 33.8399 3.84784 25.9703 1.42864 17.0614C0.0775833 12.0902 -0.343899 6.84765 0.285439 1.73212C0.400913 0.802549 1.00138 0 2.01756 0C2.86052 0 3.85938 0.796775 3.7439 1.73212Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.8229 45.1102C36.5492 40.3122 33.2812 35.5085 30.0075 30.7105C29.4821 29.9368 29.8632 28.7878 30.6311 28.3433C31.4856 27.841 32.4729 28.1874 32.9983 28.9668C36.272 33.7648 39.54 38.5686 42.8137 43.3665C43.3391 44.1402 42.958 45.2892 42.1901 45.7338C41.3356 46.2303 40.3541 45.8839 39.8229 45.1102Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4275 48.2395C38.6631 52.183 34.3905 55.6357 29.7657 58.511C28.9689 59.0018 27.8604 58.6842 27.3985 57.8875C26.9135 57.0618 27.2253 56.011 28.0221 55.5202C32.4159 52.7893 36.3997 49.5386 39.9795 45.7915C40.6261 45.116 41.7809 45.139 42.4275 45.7915C43.1088 46.467 43.08 47.5582 42.4275 48.2395Z",
  fill: "white"
});

var SvgLeftDerp = function SvgLeftDerp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 59,
    viewBox: "0 0 45 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftDerp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left-derp.8fedede7.svg";
export { ForwardRef as ReactComponent };